/**
 * Iter 67x — Coloured feature chip strip.
 *
 * Used wherever `car.features` is rendered (public car detail, Browse cards,
 * vendor preview). Resolves each free-text entry against the catalog so
 * legacy listings like "Air-Conditioning" auto-pick up the A/C icon + tone.
 */
import { featureChipsFromList } from "@/components/car/featureCatalog";

export default function CarFeatureChips({
  features = [],
  compact = false,
  className = "",
  testId = "car-feature-chips",
}) {
  if (!Array.isArray(features) || features.length === 0) return null;
  const chips = featureChipsFromList(features);
  if (chips.length === 0) return null;
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`} data-testid={testId}>
      {chips.map((c) => {
        const Icon = c.icon;
        return (
          <span
            key={c.key}
            className={`inline-flex items-center gap-1.5 ${c.tone.bg} ${c.tone.fg} ring-1 ${c.tone.ring} font-medium rounded-full ${
              compact ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1"
            }`}
            data-testid={`${testId}-${c.key}`}
            title={c.label}
          >
            <Icon className={compact ? "h-3 w-3" : "h-3.5 w-3.5"} />
            {c.label}
          </span>
        );
      })}
    </div>
  );
}
